import { useQuery } from '@tanstack/react-query';
import { CASE_PASSPORTS_KEY } from 'src/utils/constants/queryKeys';
import { getCasePassports } from '../services/ims-api/Cases';

export const useGetCasePassports = (beneId: number, caseId: number) => {
  return useQuery({
    queryKey: [CASE_PASSPORTS_KEY, beneId, caseId],
    queryFn: () => getCasePassports(beneId, caseId),
    enabled: Boolean(beneId || caseId),
  });
};
